export enum AisProviderEnum {
  GoCardless = 'GoCardless'
}